import React from 'react';
import News from '../news';

const Radioprogrammes = () => {

  return (
    <News
    pageTitle="Radio Programmes"
    metaTitle="Radio Programmes - FORLAND"
    bannerImage="/assets/images/bg1.png"
    to='/radio-programmes'
     category='Radio Programmes'
  />
  );
};

export default Radioprogrammes;